import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#4A5D23] text-white py-16">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="relative inline-block mb-4">
              <div className="absolute inset-0 bg-white/30 blur-[16px] rounded-full scale-150" />
              <img 
                src="/logo.png"
                alt="Eden's Dawn"
                className="relative h-16 brightness-0 invert drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]"
              />
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Where beautiful beginnings are created. Elegant event planning throughout The Bahamas.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/edendawnweddings"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://facebook.com/edendawnweddings"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg mb-6 text-[#D4AF37]">Quick Links</h4>
            <ul className="space-y-3">
              {['About', 'Services', 'Portfolio', 'Vendors', 'Contact'].map((link) => (
                <li key={link}>
                  <Link
                    to={`/${link.toLowerCase()}`}
                    data-testid={`footer-link-${link.toLowerCase()}`}
                    className="text-white/70 text-sm hover:text-[#D4AF37] transition-colors"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg mb-6 text-[#D4AF37]">Our Services</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>Weddings</li>
              <li>Anniversary Celebrations</li>
              <li>Dinner Parties</li>
              <li>General Parties</li>
              <li>Engagement Parties</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg mb-6 text-[#D4AF37]">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-white/70">
                <MapPin size={18} className="text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span>Nassau, The Bahamas<br />Serving All Islands</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/70">
                <Phone size={18} className="text-[#D4AF37]" />
                <a href="tel:+12425550123" className="hover:text-[#D4AF37] transition-colors">
                  +1 (242) 555-0123
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/70">
                <Mail size={18} className="text-[#D4AF37]" />
                <a href="mailto:hello@edweddingeventsandcreations.com" className="hover:text-[#D4AF37] transition-colors">
                  hello@edweddingeventsandcreations.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50">
            © {new Date().getFullYear()} Eden's Dawn Wedding Events and Creations. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-white/50">
            <Link to="/portal/login" className="hover:text-[#D4AF37] transition-colors">Client Portal</Link>
            <span>|</span>
            <Link to="/contact" className="hover:text-[#D4AF37] transition-colors">Contact</Link>
          </div>
        </div>

        {/* Powered By */}
        <div className="mt-6 flex items-center justify-center gap-1.5 opacity-40 hover:opacity-70 transition-opacity">
          <a
            href="https://www.centurionsoftwaresolutions.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-[10px] text-white/60 no-underline"
            data-testid="powered-by-centurion"
          >
            <span>Powered by</span>
            <img src="/centurion-logo.png" alt="Centurion Software Solutions" className="h-4 w-auto" />
            <span>Centurion Software Solutions</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
